import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function FailedSolutions() {
  const failures = ["Buscar 'Declarar Impuestos Gratis' en Google te lleva a anuncios de empresas que eventualmente te cobrarán.", 'Los preparadores de impuestos locales a veces cobran tarifas basadas en el tamaño de tu reembolso, lo cual es injusto.', 'Pagarle a alguien $200 por 20 minutos de trabajo que tú mismo puedes hacer con la guía correcta.'];
  return <section className="bg-offwhite py-20 md:py-24" data-id="element-17">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-19">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-dark uppercase mb-4" data-id="element-20">
            Por qué lo que has intentado no funciona
          </h2>
        </motion.div>

        <div className="space-y-6" data-id="element-21">
          {failures.map((fail, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="flex items-start bg-white p-6 rounded-lg shadow-md border-l-4 border-red-500" data-id="element-22">
              <XCircle className="w-8 h-8 text-red-500 mr-4 flex-shrink-0 mt-1" data-id="element-23" />
              <p className="text-lg text-gray-800 font-body font-semibold" data-id="element-24">
                {fail}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}